<script setup>
const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  location: {
    validator(value) {
      return [
        "bottom",
        "top",
        "right",
        "left",
        "start",
        "end",
        "center",
        "center center",
      ].includes(value);
    },
    default: "end",
  },
  secondaryColor: {
    type: Boolean,
    required: false,
    default: false,
  },
});
</script>

<template>
  <span
    :class="{
      'info-icon': true,
      [$style['info-icon']]: true,
      [$style['info-secondary']]: props.secondaryColor,
    }"
  >
    <v-icon size="x-small" icon="mdi-information"></v-icon>
    <v-tooltip
      :text="props.text"
      :location="props.location"
      activator="parent"
      max-width="300"
    />
  </span>
</template>

<style module>
.info-icon {
  display: inline-flex;
  color: #999999;
}

@media (prefers-color-scheme: dark) {
  .info-icon {
    color: rgba(255, 255, 255, 0.9);
  }
}

.info-icon:hover {
  color: rgb(124, 181, 236);
}

.info-secondary:hover {
  color: rgba(0, 0, 0, 0.4);
}

@media (prefers-color-scheme: dark) {
  .info-secondary:hover {
    color: rgba(255, 255, 255, 0.5);
  }
}

.info-icon svg {
  border: 2px solid;
  border-radius: 50%;
  padding: 0.2em;
  width: 1em;
}
</style>
